import React from "react";
import AppleLogin from "react-apple-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { Space } from "antd";
import { AppleIcon, FacebookIcon, GoogleIcon } from "assets/icons";
import {
  SESSION_TYPE,
  STORAGE_KEYS,
  TWO_FACTOR_AUTH,
} from "constants/appConstant";
import moment from "moment";
import { appleLogin, facebookLogin, googleLogin } from "stores/slices/auth";
import StorageHelper from "utils/storeHelper";

import AppButton from "components/button";

const SocialLogin = props => {
  const { loading } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  // Get id from the search parameters
  const params = useLocation();
  const searchParams = params.search.split("?");
  const searchIdParam = new URLSearchParams(searchParams[1]).get("id");

  const handleLoginWithGoogle = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async codeResponse => {
      const { code } = codeResponse;
      // console.log(window.location);
      console.log("code", code);
      if (code) {
        const { payload } = await dispatch(
          googleLogin({
            authorizeCode: code,
            redirectUrl: window.location.origin,
            acceptToken: searchIdParam ? searchIdParam : "",
            timeZone: moment.tz.guess(),
          })
        );
        if (payload && payload.status === 200) {
          const res = payload.data;
          if (res.sessionType === SESSION_TYPE.TWO_FA && res.verified) {
            StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
              maxAge: res.expireTime,
            });
            navigate("/auth/verify-two-factor-authentication");
          } else if (
            res.sessionType === SESSION_TYPE.TWO_FA &&
            res.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH &&
            !res.verified
          ) {
            StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
              maxAge: res.expireTime,
            });
            navigate("/auth/request-qr-code");
          } else {
            return;
          }
        }
      }
    },
  });

  const handleLoginWithFacebook = async response => {
    const { accessToken } = response;
    if (accessToken) {
      const { payload } = await dispatch(
        facebookLogin({
          tokenId: accessToken,
          acceptToken: searchIdParam ? searchIdParam : "",
          timeZone: moment.tz.guess(),
        })
      );
      if (payload && payload.status === 200) {
        const res = payload.data;
        if (res.sessionType === SESSION_TYPE.TWO_FA && res.verified) {
          StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
            maxAge: res.expireTime,
          });
          navigate("/auth/verify-two-factor-authentication");
        } else if (
          res.sessionType === SESSION_TYPE.TWO_FA &&
          res.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH &&
          !res.verified
        ) {
          StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
            maxAge: res.expireTime,
          });
          navigate("/auth/request-qr-code");
        } else {
          return;
        }
      }
    }
  };

  const handleLoginWithApple = async response => {
    const { authorization, user } = response;

    if (authorization && authorization.id_token) {
      const { payload } = await dispatch(
        appleLogin({
          tokenId: authorization && authorization.id_token,
          acceptToken: searchIdParam ? searchIdParam : "",
          timeZone: moment.tz.guess(),
          firstName: user && user.name.firstName,
          lastName: user && user.name.lastName,
        })
      );
      if (payload && payload.status === 200) {
        const res = payload.data;
        if (res.sessionType === SESSION_TYPE.TWO_FA && res.verified) {
          StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
            maxAge: res.expireTime,
          });
          navigate("/auth/verify-two-factor-authentication");
        } else if (
          res.sessionType === SESSION_TYPE.TWO_FA &&
          res.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH &&
          !res.verified
        ) {
          StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
            maxAge: res.expireTime,
          });
          navigate("/auth/request-qr-code");
        } else {
          return;
        }
      }
    }
  };

  return (
    <>
      <Space
        direction="vertical"
        size="small"
        style={{
          display: "flex",
        }}
      >
        {/* Google Login */}
        <AppButton
          type="submit"
          onClick={handleLoginWithGoogle}
          label={t("label.googleLabel")}
          icon={<GoogleIcon />}
          color={""}
          varient="outlined"
          className="socialButton"
          disabled={loading}
        />
        {/* Facebook Login */}
        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
          fields="name,email,picture"
          callback={handleLoginWithFacebook}
          render={renderProps => (
            <AppButton
              type="submit"
              onClick={renderProps.onClick}
              label={t("label.facebookLabel")}
              icon={<FacebookIcon />}
              color={""}
              varient="outlined"
              className="socialButton"
              disabled={loading}
            />
          )}
        />
        {/* Apple Login */}
        <AppleLogin
          clientId={process.env.REACT_APP_APPLE_CLIENT_ID}
          redirectURI={window?.location?.origin + window?.location?.pathname}
          usePopup={true}
          callback={handleLoginWithApple}
          scope="name email"
          responseMode="query"
          render={renderProps => (
            <AppButton
              type="submit"
              onClick={renderProps.onClick}
              label={t("label.appleLabel")}
              icon={<AppleIcon />}
              color={""}
              varient="outlined"
              className="socialButton"
              disabled={loading}
            />
          )}
        />
      </Space>
    </>
  );
};
export default SocialLogin;
